import { COLOR } from '../shared/shared';
import React, { ReactElement, useEffect, useState } from 'react';
import useWindowSize from './WindowSize';

interface ProgressRingProps {
	pSize: number;
	pStrokeWidth: number;
	pProgress: number;
	children: ReactElement;
}

export default function ProgressRing({
	pSize,
	pStrokeWidth,
	pProgress,
	children,
}: ProgressRingProps) {
	const [lRadius, lSetRadius] = useState<number>(pSize / 2 - pStrokeWidth * 2);
	const [lCircumference, lSetCircumference] = useState<number>(
		2 * lRadius * Math.PI
	);
	const [lDisplaySize, lSetDisplaySize] = useState<number>(pSize);
	const [lDisplayStroke, lSetDisplayStroke] = useState<number>(pStrokeWidth);
	const size = useWindowSize();
	useEffect(() => {
		if (!size.width) return;
		const lRatio = size.width / 1920;
		const lNewSize = lRatio * pSize;
		const lNewRadius = lNewSize / 2 - pStrokeWidth * 2;
		lSetRadius(lNewRadius);
		lSetCircumference(2 * lNewRadius * Math.PI);
		lSetDisplaySize(lNewSize);
		lSetDisplayStroke(lRatio * pStrokeWidth);
	}, [size]);

	const lStrokeDashOffsetFromProgress = (pProgress: number) =>
		lCircumference - (pProgress / 100) * lCircumference;
	return (
		<div className="ProgressWrap">
			<svg width={lDisplaySize} height={lDisplaySize}>
				<circle
					style={{
						strokeDasharray: `${lCircumference} ${lCircumference}`,
						strokeDashoffset: lStrokeDashOffsetFromProgress(100),
					}}
					stroke={COLOR.BORDER_GREY}
					strokeWidth={lDisplayStroke}
					fill={COLOR.TRANSPARENT}
					r={lRadius}
					cx={lDisplaySize / 2}
					cy={lDisplaySize / 2}
				/>
				<circle
					style={{
						strokeDasharray: `${lCircumference} ${lCircumference}`,
						strokeDashoffset: lStrokeDashOffsetFromProgress(pProgress),
					}}
					stroke={COLOR.GREEN}
					strokeWidth={lDisplayStroke}
					fill={COLOR.TRANSPARENT}
					r={lRadius}
					cx={lDisplaySize / 2}
					cy={lDisplaySize / 2}
				/>
			</svg>
			<div className="ProgressChildren">{children}</div>
		</div>
	);
}
